export default "__VITE_ASSET__9ffb9cff__"